import { bool, node, object, shape, string } from 'prop-types'
import { Fragment } from 'react'
import { kuiperClassNames, Conditional } from '@opallabs/kuiper'
import SlideThumbnailHeader from './SlideThumbnailHeader'
import './styles.scss'

const SlideThumbnail = ({
  children,
  className,
  renderHeader = true,
  styleOverrides = {},
  theme = {},
}) => {
  const {
    background_color: backgroundColor,
    background_image: backgroundImage,
  } = theme

  return (
    <div className={kuiperClassNames('slide-thumbnail-container')}>
      <div className={kuiperClassNames('slide-thumbnail-overlay')} />
      <div
        className={kuiperClassNames('slide-thumbnail', className)}
        css={{
          backgroundColor,
          ...styleOverrides.thumbnail,
        }}
      >
        <Conditional condition={Boolean(Object.values(theme).length)}>
          <Fragment>
            <div
              className={kuiperClassNames('background')}
              style={{ backgroundImage: `url(${backgroundImage})` }}
            />
            {renderHeader && <SlideThumbnailHeader theme={theme} />}
          </Fragment>
        </Conditional>
        {children}
      </div>
    </div>
  )
}

SlideThumbnail.propTypes = {
  children: node,
  className: string,
  renderHeader: bool,
  styleOverrides: shape({
    thumbnail: object,
  }),
  theme: shape({
    background_color: string,
    secondary_background_color: string,
    background_image: string,
    background_image_opacity: string,
    title_font_family: string,
    title_font_weight: string,
    title_font_color: string,
    title_font_size: string,
    body_font_family: string,
    body_font_weight: string,
    body_font_color: string,
    body_font_size: string,
    content_card_color: string,
    logo_alignment: string,
  }),
}

export default SlideThumbnail
